module.exports = __webpack_public_path__ + "img/安徽省计生协会.d26dab8b.jpg";